/**
 * Sets value for fieldName in session storage
 * @param fieldName
 * @returns
 */
export const getSessionStorageItem = (fieldName: string) => sessionStorage.getItem(fieldName);

/**
 * Gets value of session storage saved field
 * @param fieldName
 * @param value
 * @returns
 */
export const setSessionStorageItem = (fieldName: string, value: string) => sessionStorage.setItem(fieldName, value);
